import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import { getSupervisorBank, listSupervisorGroups, updateSupervisorBank } from '../../api/supervisor';
import './SupervisorBanqueDetailPage.css';

// Variante superviseur (2026-09-17) de pages/parametres/BanqueDetailPage.jsx —
// le select Group est deja restreint a SES groupes (listSupervisorGroups()),
// et le backend (SupervisorBankViewSet) refuse tout bank hors de son perimetre.
const SupervisorBanqueDetailPage = () => {
  const { id } = useParams();

  const [bank, setBank] = useState(null);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    Promise.all([getSupervisorBank(id), listSupervisorGroups()])
      .then(([bankData, groupsData]) => {
        if (cancelled) return;
        setBank(bankData);
        setGroups(groupsData);
      })
      .catch(() => { if (!cancelled) setError('Impossible de charger ce bank.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [id]);

  const updateField = (field, value) => {
    setBank((prev) => ({ ...prev, [field]: value }));
    setSaved(false);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSaved(false);
    try {
      const updated = await updateSupervisorBank(id, {
        name: bank.name,
        address: bank.address,
        phone: bank.phone,
        comment: bank.comment,
        group: bank.group || null,
        sale_enabled: bank.sale_enabled,
      });
      setBank(updated);
      setSaved(true);
    } catch (err) {
      setError('Sauvegarde impossible — verifie les champs et le serveur backend.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <SupervisorLayout>
        <p className="svbqd-status">Chargement...</p>
      </SupervisorLayout>
    );
  }

  if (!bank) {
    return (
      <SupervisorLayout>
        <p className="svbqd-status svbqd-error">{error || 'Bank introuvable.'}</p>
        <Link to="/supervisor/banque" className="svbqd-back">◀ Retour a la recherche</Link>
      </SupervisorLayout>
    );
  }

  return (
    <SupervisorLayout>
      <Link to="/supervisor/banque" className="svbqd-back">◀ Retour a la recherche</Link>

      <div className="svbqd-card">
        <div className="svbqd-card-header">
          <span className="svbqd-card-title">Bank Info</span>
        </div>
        <form className="svbqd-card-body" onSubmit={handleSave}>
          <div className="svbqd-row">
            <label className="svbqd-label">ID</label>
            <span className="svbqd-value">
              {bank.seq}
              {/* Meme valeur que "REF:" imprime sur les fiches du POS (ex. 4 -> 04-04). */}
              {bank.seq != null && (
                <> &nbsp;—&nbsp; Ref fiche : <strong>{String(bank.seq).padStart(2, '0')}-{String(bank.seq).padStart(2, '0')}</strong></>
              )}
            </span>
          </div>

          <div className="svbqd-row">
            <label className="svbqd-label">Username</label>
            <span className="svbqd-value">{bank.username || '—'}</span>
          </div>

          <div className="svbqd-row">
            <label className="svbqd-label">Group</label>
            <select
              className="svbqd-input"
              value={bank.group ?? ''}
              onChange={(e) => updateField('group', e.target.value ? Number(e.target.value) : null)}
            >
              <option value="">—</option>
              {groups.map((g) => (
                <option key={g.id} value={g.id}>{g.display_name || g.name}</option>
              ))}
            </select>
          </div>

          <div className="svbqd-row">
            <label className="svbqd-label">Superviseur(s)</label>
            <span className="svbqd-value">{(bank.supervisor_names || []).join(', ') || '—'}</span>
          </div>

          <div className="svbqd-row">
            <label className="svbqd-label">Name</label>
            <input
              className="svbqd-input"
              type="text"
              value={bank.name}
              onChange={(e) => updateField('name', e.target.value)}
            />
          </div>

          <div className="svbqd-row">
            <label className="svbqd-label">Address</label>
            <input
              className="svbqd-input"
              type="text"
              value={bank.address}
              onChange={(e) => updateField('address', e.target.value)}
            />
          </div>

          <div className="svbqd-row">
            <label className="svbqd-label">Phone</label>
            <input
              className="svbqd-input"
              type="text"
              value={bank.phone}
              onChange={(e) => updateField('phone', e.target.value)}
            />
          </div>

          <div className="svbqd-row svbqd-row-top">
            <label className="svbqd-label">Comments</label>
            <textarea
              className="svbqd-textarea"
              value={bank.comment}
              onChange={(e) => updateField('comment', e.target.value)}
            />
          </div>

          <label className="svbqd-checkbox-label">
            <input
              type="checkbox"
              checked={bank.sale_enabled}
              onChange={(e) => updateField('sale_enabled', e.target.checked)}
            />
            Enable Sale?
          </label>

          {error && <p className="svbqd-error">{error}</p>}
          {saved && <p className="svbqd-saved">Sauvegarde.</p>}

          <button type="submit" className="svbqd-save-btn" disabled={saving}>
            {saving ? 'Sauvegarde...' : 'Sauver'}
          </button>
        </form>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorBanqueDetailPage;
